export default __webpack_public_path__ + "static/media/temporary_background.26601718.png";